const secrets = {
    third_party_token_set: {
        token_not_found: '토큰 기록을 찾을 수 없습니다.',
        access_token_expired: '액세스 토큰이 만료되었습니다. 계정을 다시 연결해주세요.',
    },
};
export default Object.freeze(secrets);
